import { ClassGroupsTable } from 'widgets/class-groups-table';
import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Учебные группы',
    url: '',
  },
];

export const ClassGroupsPage = () => (
  <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Учебные группы">
    <ClassGroupsTable />
  </AppPage>
);
